import type { IconProps } from "../types";

/**
 * Grill: BBQ グリルアイコン。lucide-react に存在しないため registry svgContent を逐語再現。
 */
export const Grill = ({
	size = 24,
	color = "currentColor",
	strokeWidth = 2,
	className,
	"aria-label": ariaLabel,
}: IconProps) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={size}
		height={size}
		viewBox="0 0 24 24"
		fill="none"
		stroke={color}
		strokeWidth={strokeWidth}
		strokeLinecap="round"
		strokeLinejoin="round"
		className={className}
		role={ariaLabel ? "img" : undefined}
		aria-label={ariaLabel}
		aria-hidden={ariaLabel ? undefined : true}
	>
		<path d="M4 11h16" />
		<path d="M5 11v3a3 3 0 0 0 3 3h8a3 3 0 0 0 3-3v-3" />
		<path d="M8 17v4M16 17v4" />
		<path d="M9 4v4M12 3v5M15 4v4" />
	</svg>
);
